import { render } from "./DataInfoCard.vue?vue&type=template&id=40481731"
import script from "./DataInfoCard.vue?vue&type=script&lang=js"
export * from "./DataInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__